import { css } from '@linaria/core';

export const defaultAnimation = css`
  transition: opacity 300ms ease;
  opacity: 0;

  &[data-enter] {
    opacity: 1;
  }
`;
